<h6 class="text-center mt-5">
    Versione: {{environment.versione}}<br>
    Build date: {{environment.buildDate.split('T')[0]}} {{environment.buildDate.split('T')[1].substr(0, 5)}}<br>
    URL api: {{environment.api_base_url}}<br>
</h6>